var React = require('react');

function Np1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.80333 7.17322L4.57564 8.48398C4.15102 8.48398 3.68948 8.72399 3.26487 8.72399C1.7141 8.72399 0.16333 7.17322 0.16333 5.62245C0.16333 4.07168 1.04948 2.94552 2.60025 2.72398L8.80333 0.7486C10.1141 0.287061 11.2403 0.0839844 12.1264 0.0839844H12.3295C14.3418 0.0839844 15.8926 1.63475 15.8926 3.61014L15.8926 37.3024C15.8926 39.2778 14.3418 40.8286 12.3295 40.8286C10.3541 40.8286 8.80333 39.2778 8.80333 37.3024L8.80333 7.17322Z","fill":"white"}));
}

Np1.defaultProps = {"width":"16","height":"41","viewBox":"0 0 16 41"};

module.exports = Np1;

Np1.default = Np1;
